/***
 * Created on 2023/7/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {BrowserRouter, Navigate, Route, Routes, useParams} from "react-router-dom";
import NavigatorLayout from "./navigator";
import {useLanguage} from "../hook/hooks";
import PageNotFound from "./page_not_found";
import SignIn from 'auth/Signin';
import SAMLSSO from 'auth/SAML'
import SAMLLinkAccount from 'auth/SAMLLinkAccount';
import SAMLCreateAccount from 'auth/SAMLCreateAccount';
import SignupGlobal from 'auth/SignupGlobal';
import TwoStepVerification from 'auth/TwoStepVerification';
import ForgetPassword from 'auth/ForgetPassword';
import ResetPassword from 'auth/ResetPassword';
import SwitchAccount from 'auth/SwitchAccount';
import UserWarning from 'auth/UserWarning';
import InviteSignup from 'auth/InviteSignup';
import ForceChinaPhone from 'auth/ForceChinaPhone';
import DeleteQidConfirm from 'auth/DeleteQidConfirm';
import DeleteQidSuccess from 'auth/DeleteQidSuccess';
import IftttApprove from 'auth/IftttApprove';
import DeleteFacebookStatus from 'auth/DeleteFacebookStatus';
import Profile from 'accountCenter/UserProfile';
import Activity from 'accountCenter/Activity';
import Security from 'accountCenter/Security';
import Contact from 'accountCenter/Contact';
import Force2FA from 'accountCenter/Force2FA';
import StandardError from "./standard_error";

function AppMainWrapper({app_comp}) {
    const params = useParams();
    return (
         <main className="app-main">{React.createElement(app_comp, { params })}</main>
    )
}


function Router(props) {
    useLanguage();

    return (
        <BrowserRouter future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
        }}>
            <Routes>
                <Route path="/"  element={ <AppMainWrapper app_comp={SignIn} />}></Route>
                <Route path="/account" element={<NavigatorLayout />}>
                    <Route index element={<Navigate to="profile" replace={true} />}/>
                    <Route path="profile" element={<Profile />}/>
                    <Route path="security" element={<Security />}/>
                    <Route path="activity" element={<Activity />}/>
                    <Route path="contact" element={<Contact />}/>
                </Route>
                <Route path="/signin" element={<AppMainWrapper app_comp={SignIn} />}></Route>
                <Route path="/v2/mobilesignin" element={<AppMainWrapper app_comp={SignIn} />}></Route>
                <Route path="/saml/sso" element={<AppMainWrapper app_comp={SAMLSSO} />}></Route>
                <Route path="/saml/link-account" element={<AppMainWrapper app_comp={SAMLLinkAccount} />}></Route>
                <Route path="/saml/create-account" element={<AppMainWrapper app_comp={SAMLCreateAccount} />}></Route>
                <Route path="/signup" element={<AppMainWrapper app_comp={SignupGlobal} />}></Route>
                <Route path="/v2/mobilesignup" element={<AppMainWrapper app_comp={SignupGlobal} />}></Route>
                <Route path="/invitation-signup/:invite_id" element={<AppMainWrapper app_comp={InviteSignup} />}></Route>
                <Route path="/forget_password/*" element={<AppMainWrapper app_comp={ForgetPassword} />}></Route>
                <Route path="/forgetpassword/*" element={<Navigate to='/forget_password' />}></Route>
                <Route path="/resetpassword" element={<AppMainWrapper app_comp={ResetPassword} />}></Route>
                <Route path="/resetpassword/:token" element={<AppMainWrapper app_comp={ResetPassword} />}></Route>
                <Route path="/two-step-verification" element={<AppMainWrapper app_comp={TwoStepVerification} />}></Route>
                <Route path="/force-2fa-setup" element={<AppMainWrapper app_comp={Force2FA} />}></Route>
                <Route path="/switch-account" element={<AppMainWrapper app_comp={SwitchAccount} />}></Route>
                <Route path="/security_warning" element={<AppMainWrapper app_comp={UserWarning} /> }></Route>
                <Route path="/china-phone-setup" element={<AppMainWrapper app_comp={ForceChinaPhone} /> }></Route>
                <Route path="/delete-qid-confirm/:revoke_token" element={<AppMainWrapper app_comp={DeleteQidConfirm} /> }></Route>
                <Route path="/delete-qid-success" element={<AppMainWrapper app_comp={DeleteQidSuccess} /> }></Route>
                <Route path="/ifttt-approve" element={<AppMainWrapper app_comp={IftttApprove} /> }></Route>
                <Route path="/data-deletion-status" element={<AppMainWrapper app_comp={DeleteFacebookStatus} /> }></Route>
                <Route path="/oauth2callback" element={<div></div>}></Route>
                <Route path="/appleoauth2callback" element={<div></div>}></Route>
                <Route path="/error" element={<AppMainWrapper app_comp={StandardError} /> }></Route>
                <Route path="/404" element={<AppMainWrapper app_comp={PageNotFound} />}></Route>
                <Route path="*" element={<Navigate to="/404" replace />}></Route>
            </Routes>
        </BrowserRouter>
    );
}

export default Router;